import defer from '../defer';

// https://github.com/GoogleChrome/lighthouse/blob/925cb1d6a489178ee20d5727a586508dbd070245/lighthouse-core/lib/page-functions.js#L189
function benchmarkIndexGC() {
  const start = Date.now();
  let iterations = 0;

  while (Date.now() - start < 250) {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    let s = '';
    for (let j = 0; j < 10000; j++) s += 'a';

    iterations++;
  }

  const durationInSeconds = (Date.now() - start) / 1000;
  return Math.round(iterations / 10 / durationInSeconds);
}

// https://github.com/GoogleChrome/lighthouse/blob/925cb1d6a489178ee20d5727a586508dbd070245/lighthouse-core/lib/page-functions.js#L209
function benchmarkIndexNoGC() {
  const arrA = [];
  const arrB = [];
  // eslint-disable-next-line no-multi-assign
  for (let i = 0; i < 100000; i++) arrA[i] = arrB[i] = i;

  const start = Date.now();
  let iterations = 0;

  while (iterations % 10 !== 0 || Date.now() - start < 250) {
    const src = iterations % 2 === 0 ? arrA : arrB;
    const tgt = iterations % 2 === 0 ? arrB : arrA;

    for (let j = 0; j < src.length; j++) tgt[j] = src[j];

    iterations++;
  }

  const durationInSeconds = (Date.now() - start) / 1000;
  return Math.round(iterations / 10 / durationInSeconds);
}

function benchmark() {
  return 0;
  // return (benchmarkIndexGC() + benchmarkIndexNoGC()) / 2;
}

const benchmarkPromise = defer();

if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => {
    benchmarkPromise.resolve(benchmark());
  });
}

const getBenchmark = () => benchmarkPromise.promise;

export default getBenchmark;
